import ContractRoutes, { CONTRACTS_BASE_ROUTES } from './ContractRoutes';

export { ContractRoutes, CONTRACTS_BASE_ROUTES };
